/**
 * Browser/client implementation. A sibling `environmentUtils.server.ts` exists for SSR;
 * webpack picks `.server.ts` first when building the SSR bundle (see
 * config/webpack/resolve/index.ts). Both files export the same surface — keep them in sync.
 */
import config from 'js/app/config';

const isLocalDev = () => {
  return config.environment === 'development';
};

/**
 * True when the page is being driven by browser automation (e.g. Puppeteer/Playwright e2e tests).
 * `navigator.webdriver` is the W3C-standard signal both Puppeteer and Playwright set by default,
 * in headed and headless modes. The UA fallback covers headless Chrome, which always identifies
 * itself with `HeadlessChrome` regardless of the webdriver flag.
 */
const isAutomatedBrowser = () => {
  if (typeof navigator === 'undefined') return false;
  return navigator.webdriver === true || /HeadlessChrome/.test(navigator.userAgent);
};

export { isLocalDev, isAutomatedBrowser };
